import { useRef, useState, useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";

import api from "services/api";

import getQueryParams from "common/get-query-params";
import encodeQueryParams from "common/encode-query-params";
import serveRequestErrors from "common/serve-request-errors";
import serveRequestSuccess from "common/serve-request-success";

import CONSTANTS from "constants/constant";

import ActionEnum from "enum/action";

import ErrorResponseDto from "dto/services/error-response-dto";
import PageJobApplicationDto, { PageJobApplicationTableUpdatePayloadDto, PageJobApplicationTableQueryParamsDto } from "dto/pages/job-application/page-job-application-dto";

import AppHeading from "components/app-heading";
import JobApplicationTable from "components/pages/page-job-application/app-job-application-table";

const PageJobApplication = () => {
	const [jobApplicationData, setJobApplicationData] = useState<PageJobApplicationDto>();
	const [searchParams, setSearchParams] = useSearchParams();
	const memoSetSearchParams = useRef(setSearchParams);
	const [isFetching, setIsFetching] = useState(false);
	const queryParams = useRef(getQueryParams<PageJobApplicationTableQueryParamsDto>(searchParams, { page: 0 }));

	const onHandleGetJobApplication = useCallback(async () => {
		setIsFetching(true);

		try {
			const { page } = queryParams.current;
			const payload = { size: 10, page };
			const response = await api.get.jobApplication.jobs(payload);

			setJobApplicationData(response.data.data.list);
		} catch (error) {
			const err = error as Error | ErrorResponseDto;
			serveRequestErrors(err);
		} finally {
			setIsFetching(false);
		}
	}, []);

	//prettier-ignore
	const onUpdateJobStatus = useCallback(async (payload: PageJobApplicationTableUpdatePayloadDto) => {
		let response = null;

		try {
			response = await api.put.jobApplication.update({ id: payload.id }, payload);
		} catch (error) {
			const err = error as Error | ErrorResponseDto;

			serveRequestErrors(err);
		}

		if (response) {
			serveRequestSuccess(CONSTANTS.MESSAGES.UPDATED, ActionEnum.Update);

			onHandleGetJobApplication();
		}
	}, [onHandleGetJobApplication]);

	const onHandlePageChange = (page: number) => {
		queryParams.current.page = page;
		memoSetSearchParams.current(encodeQueryParams(queryParams.current));

		onHandleGetJobApplication();
	};

	useEffect(() => {
		onHandleGetJobApplication();
	}, [onHandleGetJobApplication]);

	return (
		<div className="page-job-application">
			<div className="job-application">
				<AppHeading title="Job Application">
					<AppHeading.Divider />
				</AppHeading>

				{/* prettier-ignore */}
				<JobApplicationTable applicationData={jobApplicationData?.content || []} onUpdateStatus={onUpdateJobStatus} onHandlePageChange={onHandlePageChange} fetching={isFetching} paginationTable={{currentPage: jobApplicationData?.number || 0, totalPages: jobApplicationData?.totalPages || 0, numberOfElements: jobApplicationData?.numberOfElements || 0, tableSize: jobApplicationData?.size || 10 }} />
			</div>
		</div>
	);
};

export default PageJobApplication;
